import React from 'react'
import ReactDOM from 'react-dom'

import LayoutKeyrus from 'components/Layout/LayoutKeyrus'

import './src/styles/global.css'
import './static/fonts/fonts.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import {useLayoutData} from './src/hooks/useLayoutData'

export function replaceHydrateFunction() {
  return (element, container, callback) => {
    ReactDOM.render(element, container, callback)
  }
}

export const shouldUpdateScroll = () => {
  if (window.location.href.indexOf('#') > -1) {
    return true
  }

  return [0, 0]
}

// Defined at module scope (not inside wrapPageElement) so it keeps a stable
// component identity across route updates. An inline component would be a new
// type on every navigation, forcing React to remount the whole page tree —
// which reset in-page state such as the AI intro video on hash navigation.
/* eslint-disable react/prop-types */
const Wrapper = ({element, props}) => {
  const {pageContext, pageResources} = props
  const pageIs404 = pageResources.page.path.includes('404')
  const pageIsDocument = pageContext.hasNoNavigation
  const pageHasNoNavigation = pageIs404 || pageIsDocument

  const layoutData = useLayoutData()

  return (
    <LayoutKeyrus
      pageHasNoNavigation={pageHasNoNavigation}
      layoutData={layoutData}
      {...props}
    >
      {element}
    </LayoutKeyrus>
  )
}
/* eslint-enable react/prop-types */

export const wrapPageElement = ({element, props}) => {
  const pageIsSSr = props.pageResources.page.path.includes('ssr')

  return pageIsSSr ? (
    <div>{element}</div>
  ) : (
    <Wrapper element={element} props={props} />
  )
}


let __lastPath = "";

export const onRouteUpdate = ({ location }) => {
  const path = location.pathname + location.search + location.hash;
  if (path === __lastPath) return;        // avoid duplicate fires
  __lastPath = path;

  const host = window.location.hostname;
  const isZA = /^za(\.|$)/i.test(host) || /^\/za(\/|$)/i.test(location.pathname);
  const isFR = /^fr(\.|$)/i.test(host) || /^\/fr(\/|$)/i.test(location.pathname);

  // FR-only: Smalk SPA page call (if their script exposes it)
  try {
    if (isFR) {
      if (window.smalk?.page) window.smalk.page();
      else if (window.smalk?.track) window.smalk.track("page");
    }
  } catch {}

  // ZA-only: ActiveCampaign re-process on SPA nav
  try {
    if (isZA && typeof window.vgo === "function") {
      window.vgo("process");
    }
  } catch {}
};

